import { useTranslation } from 'react-i18next'

import {
  ROUTE_PATH_LIST,
  ROUTE_UI_SECTION_NAME,
} from '../../../constants/route'
import { useSectionPermissions } from '../../../hooks'
import {
  getUserProfileCanEdit,
  UserProfileHeader,
  useUserProfileContext,
} from '../../User'
import {
  getUserProfilePageHeaderFooterActionsConfig,
  UserProfilePageHeaderFooter,
} from '../UserProfilePageHeaderFooter'

import { USER_PROFILE_PAGE_HEADER_EDIT_USERNAME_BTN_QA_NAME } from './UserProfilePageHeader.constants'
import {
  useUserProfilePageHeaderEditUsername,
  useUserProfilePageHeaderInhabitantInfoItems,
  useUserProfilePageHeaderStaffInfoItems,
} from './UserProfilePageHeader.hooks'

function UserProfilePageHeader() {
  const { isInitiated, userData } = useUserProfileContext()

  const { t } = useTranslation()

  const { canView: canViewChats } = useSectionPermissions({
    sectionName: ROUTE_UI_SECTION_NAME.chats,
  })
  const { canCreate: canCreateEmails } = useSectionPermissions({
    sectionName: ROUTE_UI_SECTION_NAME.mails,
  })

  const { handleOpenEditUsernameModal } = useUserProfilePageHeaderEditUsername()
  const { infoItemsProps: inhabitantInfoItemsProps } =
    useUserProfilePageHeaderInhabitantInfoItems()
  const { infoItemsProps: staffInfoItemsProps } =
    useUserProfilePageHeaderStaffInfoItems()

  const footerActionsConfig = getUserProfilePageHeaderFooterActionsConfig({
    canCreateEmails,
    canViewChats,
    t,
    userData,
  })

  const canEditUsername = getUserProfileCanEdit(userData)

  return (
    <UserProfileHeader
      Footer={
        !isInitiated || footerActionsConfig.primaryAction
          ? UserProfilePageHeaderFooter
          : null
      }
      footerProps={{ actionsConfig: footerActionsConfig }}
      infoItemsProps={
        userData?.isStaff ? staffInfoItemsProps : inhabitantInfoItemsProps
      }
      sectionBackUrl={`/${ROUTE_PATH_LIST.inhabitants}`}
      textProps={{
        editable: canEditUsername,
        editButtonQaName: USER_PROFILE_PAGE_HEADER_EDIT_USERNAME_BTN_QA_NAME,
      }}
      onClickEditTitleButton={handleOpenEditUsernameModal}
    />
  )
}

export default UserProfilePageHeader
